import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../core/services/auth.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private readonly _router: Router, private readonly _authService: AuthService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(err => {
        const errorStatus = err.error?.status || err.status;
        switch (true) {
          case errorStatus === 400: {
            alert('Nieobsłużony błąd: ' + errorStatus);
            break;
          }
          case errorStatus === 403: {
            alert('Nieobsłużony błąd: ' + errorStatus);

            this._authService.logout();

            break;
          }
          case errorStatus === 404: {
            // alert('Nieobsłużony błąd: ' + errorStatus);
            break;
          }
          case errorStatus >= 500: {
            alert('Nieobsłużony błąd: ' + errorStatus);
            break;
          }
        }

        return throwError(err);
      })
    );
  }
}
